import { Utils } from "./index";
import moment from "moment";

export class ApiUtils {
  static mapOrderDetailsToApi(details) {

    // REQUIRED
    // name: this.name,					//	'name'					=> ['required', 'string', 'max:255'],
    // description: this.description,		//	'description'			=> ['required', 'string'],
    // address: this.address,				//	'address'				=> ['required', 'string', 'max:255'],
    // phone: this.phone,					//	'phone'					=> ['required', 'string'],
    const orderBody = {
      name: details.name,
      description: details.description,
      address: details.address,
      phone: details.phone,
    }

    // SOMETIMES
    // contactName: this.contactName,		//	'primary_contact_name'	=> ['sometimes', 'string', 'max:255'],
    if (details.contactName) {
      orderBody.primary_contact_name = details.contactName;
    }

    // dateStart: this.dateStart,			//	'start'					=> ['sometimes', 'date', 'date_format:Y-m-d H:i:s', 'after:' . now()->format('Y-m-d H:i:s')],
    // timeStart: this.timeStart,			//
    if (details.dateStart && details.timeStart) {
      orderBody.start = new Date(`${Utils.parseDate(details.dateStart)} ${details.timeStart}`);
    } else if (details.dateStart && !details.timeStart) {
      orderBody.start = new Date(`${Utils.parseDate(details.dateStart)}`);
    } else {
      orderBody.start = null;
    }

    // dateEnd: this.dateEnd,				//	'end'					=> ['sometimes', 'date', 'date_format:Y-m-d H:i:s', 'after:' . now()->format('Y-m-d H:i:s')],
    // timeEnd: this.timeEnd,				//
    // event: this.event,					//

    if (!details.event) {
      if (details.dateEnd && details.timeEnd) {
        orderBody.end = new Date(`${Utils.parseDate(details.dateEnd)} ${details.timeEnd}`).toUTC();
      } else if (details.dateEnd && !details.timeEnd) {
        orderBody.end = new Date(`${Utils.parseDate(details.dateEnd)}`).toUTC();
      } else {
        orderBody.end = null;
      }
    } else {
      orderBody.end = null;
    }

    // 'delivery_date'				=> ['sometimes', 'date', 'date_format:Y-m-d H:i:s', 'after:' . now()->format('Y-m-d H:i:s')],
    let dateObj = '';
    if (details.deliveryDate && details.deliveryTime) {
      dateObj = new Date(`${Utils.parseDate(details.deliveryDate)} ${details.deliveryTime}`).toUTC();
    } else if (details.deliveryDate && !details.deliveryTime) {
      dateObj = new Date(`${Utils.parseDate(details.deliveryDate)}`).toUTC();
    } else {
      // NOTHING
    }

    let deliveryDate;
    const {timezone} = details;
    if (timezone) {
      if (timezone.offset === 'GMT') {
        deliveryDate = Utils.normalizeDateForApi(dateObj)
      } else {
        if (timezone.offset[3] && timezone.offset[3] === '+') {
          const addValue = +`${timezone.offset[4]}${timezone.offset[5]}`
          const newDate = moment(dateObj).add(addValue, 'hours');
          deliveryDate = Utils.normalizeDateForApi(newDate._d);
        } else if (timezone.offset[3] && timezone.offset[3] === '-') {
          const substractValue = +`${timezone.offset[4]}${timezone.offset[5]}`
          const newDate = moment(dateObj).subtract(substractValue, 'hours');
          deliveryDate = Utils.normalizeDateForApi(newDate._d);
        }
      }
    }

    orderBody.delivery_date = deliveryDate;

    // 'timezone'					=> ['sometimes', 'string', 'max:255'],
    if (details.timezone) {
      orderBody.timezone = details.timezone.name;
    } else {
      orderBody.timezone = 'ok';
    }

    // 'delivery_location'			=> ['sometimes', 'string'],
    if (details.delivery_location) {
      orderBody.delivery_location = details.location
    }

    // 'state'						=> ['sometimes', 'string'],
    if (details.state) {
      orderBody.state = details.state
    }

    // 'city'						=> ['sometimes', 'string'],
    if (details.city) {
      orderBody.city = details.city
    }

    // 'zipcode'					=> ['sometimes', 'string'],
    if (details.zipcode) {
      orderBody.zipcode = details.zipcode
    }


    // snapchat: this.snapchat,				//	'snapchat_link'			=> ['sometimes', 'string', 'max:255'],
    if (details.snapchat) {
      orderBody.snapchat_link = details.snapchat
    }

    // twitter: this.twitter,				//	'twitter_link'			=> ['sometimes', 'string', 'max:255'],
    if (details.twitter) {
      orderBody.twitter_link = details.twitter
    }

    // facebook: this.facebook,				//	'facebook_link'			=> ['sometimes', 'string', 'max:255'],
    if (details.facebook) {
      orderBody.facebook_link = details.twitter
    }

    // instagram: this.instagram,			//	'instagram_link'		=> ['sometimes', 'string', 'max:255'],
    if (details.instagram) {
      orderBody.instagram_link = details.instagram
    }

    // linkedin: this.linkedin				//	'linkedin_link'			=> ['sometimes', 'string', 'max:255'],
    if (details.linkedin) {
      orderBody.linkedin_link = details.linkedin
    }

    return orderBody;
  }

  static mapOrderMenuToApi(orderId, menu) {
    const body = {
      categories: menu.map(category => ({
        id: category.id,
        position: category.position,
        items_quantity: category.quantity,
        items: category.items.map(item => ({
          id: item.id,
          is_default: item.isDefault ? 1 : 0,
          position: item.position,
        }))
      }))
    };

    if (orderId) {
      body.order_id = orderId
    }

    return body;
  }

  static mapOrderAttendeesToApi(attendees) {
    return {
      attendees: attendees.map(attendee => ({
        first_name: attendee.firstName,
        last_name: attendee.lastName,
        email: attendee.email
      }))
    }
  }

  /*
   * BACKEND
   *
      'name'						=> ['required', 'string', 'max:255'],
      'description'				=> ['sometimes', 'string'],
      'subject'					=> ['sometimes', 'string', 'max:255'],
      'message'					=> ['required', 'string'],

      'target'					=> ['sometimes', 'numeric', new Exists('characters','id')],		// NULL (all attendees) or ID of the CHARACTER

      'depends_on_event'			=> ['sometimes', 'numeric'],									// SECONDS BEFORE or AFTER THE EVENT
      'before_event'				=> ['required_with:depends_on_event', 'numeric'],				// BEFORE 1 or AFTER 0
      'event_id'					=> ['nullable', 'numeric', new Exists('events','id')],			// TRIGGER ID

      'depends_on'				=> ['sometimes', 'numeric', new Exists('messages','id')],		// MESSAGE DEPENDS ON OTHER - NOT NEEDED.
      'delay'						=> ['required_with:depends_on', 'numeric'],						// DELAY BETWEEN MESSAGES RELATED BY "DEPENDS ON" - NOT NEEDED

      'send_at'					=> ['required_without_all:depends_on_event,depends_on','date', 'date_format:Y-m-d H:i:s'],	// SEND AT DATE+TIME
   *
   */

  static mapOrderMessageToApi(message, update = false) {
    const body = {};

    if (update && message.id) {
      body.id = message.id;
    }

    body.name = message.name;
    body.description = message.description;
    body.subject = message.subject;
    body.message = message.message;
    body.target = message.target;

    if (message.delayCount != null) {
      switch (message.delayUnit) {
        case 'day':
          body.depends_on_event = message.delayCount * 60 * 24;
          break;
        case 'hour':
          body.depends_on_event = message.delayCount * 60;
          break;
        case 'minute':
          body.depends_on_event = message.delayCount;
          break;
        default:
          body.depends_on_event = null;
      }
    }

    if (message.delayDirection != null) {
      body.before_event = parseInt(message.delayDirection);
    }

    // SENT_AT needs to be sended if there are some info, if not, send the event_id instead.
    if (message.date != null && message.time != null) {
      const date = moment(message.date).format('YYYY-MM-DD')
      body.send_at = `${date} ${message.time}`
    } else {
      body.event_id = message.selectedTrigger;
    }

    return body;
  }

  static mapOrderCharactersToApi(characters) {
    const formData = new FormData();
    formData.append('_method', 'put');

    characters.forEach((character, index) => {
      formData.append(`characters[${index}][id]`, character.id)
      formData.append(`characters[${index}][name]`, character.name);
      formData.append(`characters[${index}][description]`, character.description);
      formData.append(`characters[${index}][disclaimer]`, character.disclaimer);

      if (character.imageFile) {
        formData.append(`characters[${index}][file]`, character.imageFile);
      } else {
        formData.append(`characters[${index}][path]`, character.image);
      }
    })

    return formData;
  }

  static mapOrderCategoriesToApi(orderId, categories) {
    const formData = new FormData();
    formData.append('_method', 'put');
    categories.forEach((category, index) => {
      if (category.id != null) {
        formData.append(`categories[${index}][id]`, category.id);
      }
      formData.append(`categories[${index}][name]`, category.name);
      formData.append(`categories[${index}][description]`, category.description);
      formData.append(`categories[${index}][position]`, category.position);
      formData.append(`categories[${index}][quantity]`, category.quantity);

      if (category.imageFile) {
        formData.append(`categories[${index}][file]`, category.imageFile);
      } else {
        formData.append(`categories[${index}][id]`, category.id)
        formData.append(`categories[${index}][path]`, category.image);
      }
    })

    formData.append('order_id', orderId)

    return formData;

  }

  static mapNameCategoriesToApi(orderId, categories) {
    const formData = new FormData();
    formData.append('_method', 'put');
    categories.forEach((category, index) => {
      formData.append(`categories[${index}][id]`, category.id);
      formData.append(`categories[${index}][name]`, category.name);
    })

    formData.append('order_id', orderId)

    return formData;
  }

  static mapOrderLineItemsToApi(orderId, lineItems) {
    console.log(lineItems)
    const formData = new FormData();
    formData.append('_method', 'put');

    lineItems.forEach((category, iCategory) => {
      formData.append(`categories[${iCategory}][id]`, category.id)

      category.items.forEach((item, iItem) => {
        formData.append(`categories[${iCategory}][items][${iItem}][name]`, item.name)
        formData.append(`categories[${iCategory}][items][${iItem}][description]`, item.description)
        formData.append(`categories[${iCategory}][items][${iItem}][price]`, item.price)
        formData.append(`categories[${iCategory}][items][${iItem}][position]`, item.position)

        if (item.imageFile) {
          formData.append(`categories[${iCategory}][items][${iItem}][file]`, item.imageFile);
        } else {
          formData.append(`categories[${iCategory}][items][${iItem}][id]`, item.id)
          formData.append(`categories[${iCategory}][items][${iItem}][path]`, item.image);
        }
      })

    })

    formData.append('order_id', orderId)
    return formData;
  }

  static extractBackendErrors(e) {
    if (!e.response) {
      return e.message;
    }
    if (e.response.data.errors) {
      return e.response.data.errors;
    }
    return e.response.data.message;
  }
}
